import { fetchData } from "../helpers/fetchData";

export const getUserList = async (params) => {
  try {
    const res = await fetchData("get", "/admin-employee-list", {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const getUserListForManager = async (params) => {
  try {
    const res = await fetchData("get", "/fetch-employee-for-sso", {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};


export const getPositionList = async (params) => {
    try {
      const res = await fetchData("get", "/position", {
        queries: params,
      });
      return res?.data;
    } catch (error) {
      return error;
    }
  };

  export const getDepartmentList = async (params) => {
    try {
      const res = await fetchData("get", "/recursive-group-list", {
        queries: params,
      });
      return res?.data;
    } catch (error) {
      return error;
    }
  };

  export const getRoleList = async (params) => {
    try {
      const res = await fetchData("get", "/roles", {
        queries: params,
      });
      return res?.data;
    } catch (error) {
      return error;
    }
  };
  

export const syncGenarateToken = async (params) => {
  try {
    const res = await fetchData("post", "generate/token", {
      body: params,
    });

    return res?.data;
  } catch (error) {
    return error;
  }
};

export const syncGenarateTokenForAdmin = async (params) => {
  try {
    const res = await fetchData("post", "generate-token-extended", {
      body: params,
    });

    return res?.data;
  } catch (error) {
    return error;
  }
};

export const syncRecord = async (params) => {
  try {
    const res = await fetchData("post", "/get-sync-record", {
      body: params,
    });

    return res?.data;
  } catch (error) {
    return error;
  }
};
